const PREFIX = 'RELEASE_FLAGS_';

export const UPDATE_FLAGS_FOR_ORGS_REQUEST = `${PREFIX}UPDATE_FLAGS_FOR_ORGS_REQUEST`;
export const UPDATE_FLAGS_FOR_ORGS_SUCCESS = `${PREFIX}UPDATE_FLAGS_FOR_ORGS_SUCCESS`;
export const UPDATE_FLAGS_FOR_ORGS_ERROR = `${PREFIX}UPDATE_FLAGS_FOR_ORGS_ERROR`;
